import { Timeslot } from "@platform/features/timeslots/timeslots.types";

export function groupTimeslotsByTime(timeSlots: Timeslot[]) {
  const grouped = new Map<string, Timeslot[]>([]);

  for (const slot of timeSlots) {
    const key = slot.local.start.formattedTime;

    if (!grouped.has(key)) {
      grouped.set(key, []);
    }

    grouped.get(key)!.push(slot);
  }

  return [...grouped.entries()].sort((a, b) => {
    const [timeA] = a;
    const [timeB] = b;

    const [hourA, minuteA] = timeA.split(":").map(Number);
    const [hourB, minuteB] = timeB.split(":").map(Number);

    return hourA !== hourB ? hourA - hourB : minuteA - minuteB;
  });
}

export default groupTimeslotsByTime;
